/**
 * 把后端下发的权限树（adminUser.permissionPathList，IFrontPermissionNode 结构：
 * frontPath / frontTitle / permissionList[].frontCode / children）转换为侧边栏菜单
 * 过滤所需的 functionList 结构（path / permissionList[].code / children），字段映射：
 *   frontPath   → path
 *   frontCode   → code
 *   children    → children（递归）
 * 侧边栏仅依赖 path + 二级菜单是否含 read 权限做显隐判断，三级子页（frontRelationPermission
 * 关联）不参与菜单过滤，递归保留即可。
 */
export const mapPermissionPathListToFunctionList = (tree: any[]): any[] => {
  const mapNode = (node: any) => ({
    path: node.frontPath,
    ...(node.permissionList?.length
      ? { permissionList: node.permissionList.map((p: any) => ({ code: p.frontCode })) }
      : {}),
    ...(node.children?.length ? { children: node.children.map(mapNode) } : {}),
  });
  return (tree ?? []).map(mapNode);
};
